import React, { useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import axios from "axios";
import MapDashboard from "./MapDashboard";
import MapDashboardOld from "./MapDashboardOld";
import { useGlobalContext } from "../../GlobalContext";
import { AnimatePresence, motion } from "framer-motion";
export default function DashboardContainer() {
  const {
    baseurl,
    token,
    accessToken,
    ApiCall,
    setIsUnauthorised,
    socketData,
    teams = [],
    selectedTeam = "All Team",
    setSelectedTeam,
    AdminId
  } = useGlobalContext();

  const [tasks, setTasks] = useState([]);
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [shops, setShops] = useState([]);
  const [shopsLoaded, setShopsLoaded] = useState(false);
  const [isAutoAssignChecked, setIsAutoAssignChecked] = useState(true);
  const [autoAssignLoading, setAutoAssignLoading] = useState(false);
  const { showOld, setShowOld } = useGlobalContext();

  useEffect(() => {
    const today = new Date();
    const format = (date) => date.toISOString().split("T")[0];
    setToDate(format(today));
    setFromDate(format(today));
  }, []);

  const FetchTaskCall = useCallback(async () => {
    if (!baseurl || !token || !fromDate || !toDate) return;

    setIsLoading(true);
    try {
      const UserDetail = {
        adminId: AdminId,
        driverId: "",
        fromDate,
        toDate,
        status: [
          "unassigned",
          "assigned",
          "started",
          "inprogress",
          "Successful",
          "food is ready",
          "acknowledged",
          "failed",
          "declined",
          "cancelled",
          "picked up",
          "arrived",
          "delayed",
        ],
      };

      const response = await axios.post(
        `${baseurl}/api/Task/v1.0/getTasks`,
        UserDetail,
        {
          headers: {
            Authorization: `Basic ${token}`,
          },
        }
      );

      if (response.data?.responseCode === "00") {
        setTasks(response.data.data || []);
      } else if (response.data?.responseCode === "401") {
        setIsUnauthorised(true);
      } else if (response.data?.responseCode === "01") {
        setTasks([]);
      } else {
        toast.error(response.data?.responseMessage || "Error fetching tasks");
      }
    } catch (error) {
      console.error("Error fetching tasks:", error);
      toast.error("Error fetching tasks");
    } finally {
      setIsLoading(false);
    }
  }, [baseurl, token, fromDate, toDate, setIsUnauthorised]);

  const FetchDriverCall = useCallback(async () => {
    if (!baseurl || !token) return;

    try {
      const UserDetail = {
        userid: "", adminId: AdminId
      };

      const response = await axios.post(
        `${baseurl}/api/Driver/v1.0/getDriverList`,
        UserDetail,
        {
          headers: {
            Authorization: `Basic ${token}`,
          },
        }
      );

      if (response.data?.responseCode === "00") {
        setAgents(response.data.data || []);
      } else if (response.data?.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(response.data?.responseMessage || "Error fetching drivers");
      }
    } catch (error) {
      console.error("Error fetching drivers:", error);
      toast.error("Error fetching Driver");
    } finally {
      setLoading(false);
    }
  }, [baseurl, token, setIsUnauthorised]);

  const fetchShops = useCallback(async () => {
    const response = await axios.post(
      `${baseurl}/api/Shop/v1.0/getShopList`,
      { userid: "", adminId: AdminId },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );

    if (response.data?.responseCode === "00") {
      setShops(response.data.data || []);
      //   toast.success(response.data.responseMessage);
    } else if (response.data?.responseCode === "401") {
      setIsUnauthorised(true);
    } else {
      toast.error(response.data?.responseMessage || "Error fetching drivers");
    }
  }, []);

  const [isChecked, setIsChecked] = useState(false);

  const handleToggle = async () => {
    const newValue = !isChecked;
    setIsChecked(newValue);
    setLoading(true);

    const payload = {
      configType: "auto_assign_status",
      configValue1: newValue ? "Y" : "N",
      configValue2: "",
      configValue3: "",
      configValue4: "",
      adminId: AdminId
    };

    try {
      const response = await axios.post(
        `${baseurl}/api/Task/v1.0/updateAutoAssignConfig`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.data.responseCode === "401") {
        setIsUnauthorised(true);
      }
    } catch (err) {
      console.error("Error updating config:", err);
    } finally {
      setLoading(false);
      ShowToggleStatus();
    }
  };

  const ShowToggleStatus = async () => {
    setLoading(true);
    const payload = {
      configType: "auto_assign_status", adminId: AdminId
    };

    try {
      const response = await axios.post(
        `${baseurl}/api/Task/v1.0/getAutoAssignConfig`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (
        response.data?.responseCode === "00" &&
        response.data?.data?.configValue
      ) {
        const isOn = response.data.data.configValue === "Y";
        setIsChecked(isOn);
      } else if (response.data.responseCode === "401") {
        setIsUnauthorised(true);
      }
    } catch (err) {
      console.error("Error fetching toggle status:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    ShowToggleStatus();
  }, []);

  const SyncWithAnlook = async (taskId) => {
    try {
      const UserDetail = {
        taskId: taskId, adminId: AdminId
      };

      const response = await axios.post(
        `${baseurl}/api/Task/v1.0/syncDeliveryDetailsWithPartner`,
        UserDetail,
        {
          headers: {
            Authorization: `Basic ${token}`,
          },
        }
      );

      if (response.data?.responseCode === "00") {
        toast.success(response.data.responseMessage);
      } else if (response.data?.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(
          response.data?.responseMessage || "Error syncing with Anlook"
        );
      }
    } catch (error) {
      console.error("Error syncing with Anlook:", error);
      toast.error("Error syncing with Anlook");
    }
  };

  const AssignTaskToDriver = async (taskId, driverId) => {
    if (!taskId || !driverId) {
      toast.error("Task or Driver not selected");
      return;
    }

    const payload = {
      taskId: taskId,
      driverId: driverId, adminId: AdminId
    };

    try {
      const response = await axios.post(
        `${baseurl}/api/Task/v1.0/assignDriver`,
        payload,
        {
          headers: {
            Authorization: `Basic ${token}`,
          },
        }
      );

      if (response.data?.responseCode === "00") {
        toast.success(response.data.responseMessage);
        FetchTaskCall();
        return true;
      } else if (response.data?.responseCode === "401") {
        setIsUnauthorised(true);
        return false;
      } else {
        toast.error(response.data?.responseMessage || "Error assigning driver");
        return false;
      }
    } catch (error) {
      console.error("Error assigning driver:", error);
      toast.error("Error assigning driver");
      return false;
    }
  };

  useEffect(() => {
    if (baseurl && accessToken && !shopsLoaded) {
      fetchShops();
      setShopsLoaded(true);
    }
  }, [baseurl, accessToken, shopsLoaded, fetchShops]);

  useEffect(() => {
    if (baseurl && token && fromDate && toDate) {
      FetchTaskCall();
    }
  }, [baseurl, token, fromDate, toDate, FetchTaskCall]);

  useEffect(() => {
    if (baseurl && token) {
      FetchDriverCall();
    }
  }, [baseurl, token, FetchDriverCall]);

  useEffect(() => {
    if (ApiCall || socketData) {
      FetchTaskCall();
    }
  }, [ApiCall, socketData, FetchTaskCall]);

  const commonProps = {
    tasks: tasks,
    agents: agents,
    loading: loading,
    isLoading: isLoading,
    fromDate: fromDate,
    toDate: toDate,
    shops: shops,
    isAutoAssignChecked: isAutoAssignChecked,
    autoAssignLoading: autoAssignLoading,
    teams: teams,
    selectedTeam: selectedTeam,
    setSelectedTeam: setSelectedTeam,
    setFromDate: setFromDate,
    setToDate: setToDate,
    FetchTaskCall: FetchTaskCall,
    FetchDriverCall: FetchDriverCall,
    SyncWithAnlook: SyncWithAnlook,
    AssignTaskToDriver: AssignTaskToDriver,
    handleToggle: handleToggle,
    ShowToggleStatus: ShowToggleStatus,
    isChecked,
    setIsChecked,
    baseurl: baseurl,
    token: token,
    accessToken: accessToken,
    setIsUnauthorised: setIsUnauthorised,
    showOld: showOld,
    setShowOld: setShowOld,
  };
  const direction = showOld ? 1 : -1;

  const slideVariants = {
    enter: (dir) => ({
      x: `${dir * 100}%`,
      opacity: 1,
      position: "absolute",
      top: 0, right: 0, bottom: 0, left: 0,
    }),
    center: {
      x: "0%",
      opacity: 1,
      position: "absolute",
      top: 0, right: 0, bottom: 0, left: 0,
    },
    exit: (dir) => ({
      x: `${-dir * 100}%`,
      opacity: 1,
      position: "absolute",
      top: 0, right: 0, bottom: 0, left: 0,
    }),
  };

  return (
    <div className="h-full relative flex-1 overflow-hidden">
      <AnimatePresence custom={direction}>
        <motion.div
          key={showOld ? "old" : "new"}
          custom={direction}
          variants={slideVariants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{ type: "spring", stiffness: 320, damping: 32, mass: 0.8 }}
          className="h-full"
        >
          {showOld ? (
            <MapDashboardOld {...commonProps} />
          ) : (
            <MapDashboard {...commonProps} />
          )}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
